<template>
  <el-button
    type="success"
    round
    @click="addCourseForm = true"
    class="courseBtn"
  >
    创建课程
  </el-button>
  <!-- 添加课程表单 -->
  <el-dialog
    v-model="addCourseForm"
    title="创建课程"
    width="500"
    destroy-on-close
    center
  >
    <span>
      <div class="mb-3 row">
        <label for="courseName" class="col-sm-2 col-form-label inputs"
          >课程名</label
        >
        <div class="col-sm-9">
          <input type="text" class="form-control" id="courseName" />
        </div>
        <div class="col-sm-1">
          <span style="color: red">*</span>
        </div>
      </div>
      <div class="mb-3 row">
        <label for="courseImg" class="col-sm-2 col-form-label">封面</label>
        <div class="col-sm-9">
          <input class="form-control" type="file" id="courseImg" />
        </div>
        <div class="col-sm-1">
          <span style="color: red">*</span>
        </div>
      </div>
      <div class="mb-3 row">
        <label for="isPublic" class="col-sm-2 col-form-label">属性</label>
        <div class="col-sm-9">
          <select
            class="form-select"
            id="isPublic"
            name="isPublic"
            v-model="isPublic"
          >
            <option value="0" selected>公开课</option>
            <option value="1">私有课</option>
          </select>
        </div>
        <div class="col-sm-1">
          <span style="color: red">*</span>
        </div>
      </div>

      <div class="mb-3 row" v-if="isPublic == 1">
        <label for="addCode" class="col-sm-2 col-form-label inputs"
          >加课码</label
        >
        <div class="col-sm-9">
          <input type="text" class="form-control" id="addCode" />
        </div>
        <div class="col-sm-1">
          <span style="color: red">*</span>
        </div>
      </div>
      <div class="mb-3 row">
        <label class="col-sm-2 col-form-label inputs"
          >分类</label>
        <div class="demo-button-style col-sm-9">
          <el-checkbox-group v-model="checkCate" size="small">
            <el-checkbox-button v-for="cate in cateList" :key="cate.cateId" :label="cate.cateId" :value="cate.cateId">
            {{ cate.cateName }}
          </el-checkbox-button>
          </el-checkbox-group>
        </div>
        <div class="col-sm-1">
          <span style="color: red">*</span>
        </div>
    </div>

      <div class="mb-3 row">
        <label for="describes" class="col-sm-2 col-form-label">描述</label>
        <div class="col-sm-10">
          <textarea class="form-control" id="describes"></textarea>
        </div>
      </div>
    </span>
    <div></div>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="addCourseForm = false">取消</el-button>
        <el-button type="button" @click="addCourse()" v-loading="createLoading">
          提交
        </el-button>
      </div>
    </template>
  </el-dialog>

  <!-- 课程列表 -->
  <table class="table caption-top">
    <caption>
      我的课程
    </caption>
    <thead>
      <tr>
        <th scope="col">课程名称</th>
        <th scope="col">课程封面</th>
        <th scope="col">课程人数</th>
        <th scope="col">课程属性</th>
        <th scope="col">课程状态</th>
        <!-- <th scope="col">创建时间</th> -->
        <th scope="col">操作</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="course in courses" :key="course.courseId">
        <th scope="row" :title="course.courseName">{{ course.courseName.substr(0, 12) }}</th>
        <td>
          <img
            :src="course.courseImg"
            alt=""
            style="width: 140px; height: 70px"
          />
        </td>
        <td>{{ course.headCount }}</td>
        <td>
          <el-button type="success" v-if="course.isPublic == 0" plain
            >公开课</el-button
          >
          <el-tooltip :content="'加课码: ' + course.addCode" placement="bottom">
            <el-button type="warning" v-if="course.isPublic == 1" plain
              >私有课</el-button
            >
          </el-tooltip>
        </td>
        <td>
          <el-popconfirm
            title="确定暂停课程吗？"
            @confirm="changeCourseState(course.states, course.courseId)"
            confirm-button-text="确认"
            cancel-button-text="取消"
            confirm-button-type="danger"
          >
            <template #reference>
              <el-button type="primary" v-if="course.states == 1" plain
                >开课中</el-button
              >
            </template>
          </el-popconfirm>

          <el-popconfirm
            title="确定恢复课程吗？"
            @confirm="changeCourseState(course.states, course.courseId)"
            confirm-button-text="确认"
            cancel-button-text="取消"
            confirm-button-type="danger"
          >
            <template #reference>
              <el-button type="info" v-if="course.states == 0" plain
                >暂停中</el-button
              >
            </template>
          </el-popconfirm>
        </td>
        <!-- <td>{{ course.createTime }}</td> -->
        <td>
          <el-button type="success" plain>
            <router-link class="nav-link" :to="{ name: 'MyCourse', params: { courseId: course.courseId } }">
              查看课程
              <el-icon><DataAnalysis /></el-icon>
            </router-link>
          </el-button>

          <el-button type="warning" plain>
            <router-link class="nav-link" :to="{ name: 'ApplyList', params: { page: 1, courseId: course.courseId } }">
              审批
              <el-icon><Histogram /></el-icon>
            </router-link>
          </el-button>

          <el-button type="danger" plain>
            <router-link class="nav-link" :to="{ name: 'StudentManager', params: { page: 1, courseId: course.courseId, keyword: '' } }">
              学生管理
              <el-icon><Avatar /></el-icon>
            </router-link>
          </el-button>
        </td>
      </tr>
    </tbody>
  </table>

  <nav aria-label="...">
    <ul class="pagination" style="float: center">
      <li class="page-item" @click="click_page(-2)">
        <a class="page-link" href="#">前一页</a>
      </li>
      <li
        :class="'page-item ' + page.is_active"
        v-for="page in pages"
        :key="page.number"
        @click="click_page(page.number)"
      >
        <a class="page-link" href="#">{{ page.number }}</a>
      </li>
      <li class="page-item" @click="click_page(-1)">
        <a class="page-link" href="#">后一页</a>
      </li>
    </ul>
  </nav>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { ElMessage } from "element-plus";
import $ from "jquery";
import { useRoute } from "vue-router";
import router from "@/router/index";

const addCourseForm = ref(false);
const isPublic = ref(0);
const createLoading = ref(false);
let courses = ref([]);
let current_page = 1;
let total_course = 0;
let pages = ref([]);
let cateList = ref([]);
const checkCate = ref([]);
const Route = useRoute(); //获取到值


// 在组件初始化时获取路由参数并设置为 current_page
onMounted(() => {
  // 获取路由参数并设置为 current_page
  current_page = parseInt(Route.params.page) || 1;
  pullCourse(current_page);
  getAllCate();
});


const getAllCate = () => {
    $.ajax({
        url: "http://124.222.105.205:5000/get/api/cate/getAllCate",
        type: "post",
        success(resp) {
            cateList.value = resp.data;
            console.log(cateList.value);
        },
        error() {
        },
    });
}

// 加载课程信息
const pullCourse = (page) => {
  current_page = page;
  const token = localStorage.getItem("token");
  $.ajax({
    url: "http://124.222.105.205:5000/api/course/getCourseList",
    data: {
      page,
    },
    type: "post",
    headers: {
      Authorization: "Bearer " + token,
    },
    success(resp) {
      courses.value = resp.data.list;
      total_course = resp.data.total;
      udpate_pages();
    },
    error(resp) {
      console.log(resp);
    },
  });
};

const click_page = (page) => {
  if (page === -2) page = current_page - 1;
  else if (page === -1) page = current_page + 1;
  let max_pages = parseInt(Math.ceil(total_course / 5));

  if (page >= 1 && page <= max_pages) {
    pullCourse(page);
  }
};

const udpate_pages = () => {
  let max_pages = parseInt(Math.ceil(total_course / 5));
  let new_pages = [];
  for (let i = current_page - 2; i <= current_page + 2; i++) {
    if (i >= 1 && i <= max_pages) {
      new_pages.push({
        number: i,
        is_active: i === current_page ? "active" : "",
      });
    }
  }
  pages.value = new_pages;
  router.push({ name: "CourseList", params: { page: current_page } });
};

// 创建课程
const addCourse = () => {


  // 判断课程名
  let courseName = $("#courseName").val();
  if (courseName == "") {
    ElMessage({
      type: "error",
      message: "课程名不能为空！",
    });
    return false;
  }

  // 判断封面
  if ($("#courseImg")[0].files.length == 0) {
    ElMessage({
      type: "error",
      message: "课程名封面未上传！",
    });
    return false;
  }

  // 判断加课码
  if (isPublic.value == 1 && $("#addCode").val() == "") {
    ElMessage({
      type: "error",
      message: "加课码不能为空！",
    });
    return false;
  }

  // 判断分类
  if (checkCate.value.length == 0) {
    ElMessage({
      type: "error",
      message: "分类不能为空",
    });
    return false;
  }

  const token = localStorage.getItem("token");

  var formData = new FormData();
  formData.append("file", $("#courseImg")[0].files[0]); // 添加课程封面
  formData.append("courseName", $("#courseName").val()); // 添加课程名
  formData.append("isPublic", isPublic.value); // 添加属性
  formData.append("addCode", isPublic.value == 0 ? "" : $("#addCode").val()); // 添加加课码
  formData.append("describes", $("#describes").val()); // 添加加课码
  formData.append("cateList",checkCate.value); // 添加分类


  createLoading.value = true;
  // 创建课程
  $.ajax({
    url: "http://124.222.105.205:5000/api/course/CreateCourse",
    type: "post",
    data: formData,
    headers: {
      Authorization: "Bearer " + token,
    },
    processData: false, // 告诉jQuery不要去处理发送的数据
    contentType: false, // 告诉jQuery不要去设置Content-Type请求头
    dataType: "text",
    success: function (resp) {
      let result = JSON.parse(resp);
      if (result.code == "200") {
        ElMessage({
          type: "success",
          message: result.msg,
        });
        addCourseForm.value = false;
        location.reload();
      } else {
        ElMessage({
          type: "error",
          message: result.msg,
        });
      }
    },
    error: function () {
      ElMessage({
        type: "error",
        message: "创建课程失败！",
      });
    },
  });
  createLoading.value = false;
};

const changeCourseState = (state, id) => {
  const token = localStorage.getItem("token");
  $.ajax({
    url: "http://124.222.105.205:5000/api/course/updateStates",
    data: {
      states: state,
      id: id,
    },
    type: "post",
    headers: {
      Authorization: "Bearer " + token,
    },
    success(resp) {
      if (resp.code == "200") {
        ElMessage({
          type: "success",
          message: resp.msg,
        });
      } else {
        ElMessage({
          type: "error",
          message: resp.msg,
        });
      }

      pullCourse(current_page);
    },
    error() {
      ElMessage({
        type: "error",
        message: "修改课程状态失败",
      });
    },
  });
};
</script>

<style scoped>
.courseBtn {
  float: right;
}

.inputs {
  display: inline-block;
}
</style>